import React, { Component } from 'react';
import { Link } from "react-router-dom";

export class Codes extends Component {
    constructor(props) {
        super(props);
        this.state = { codes: null, loading: true };
    }

    componentDidMount() {
        this.fetchCodes();
    }

    static renderCodes(codes) {
        return (
            <table className='table table-striped' aria-labelledby="tableLabel">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Campaign Id</th>
                        <th>Facility Id</th>
                        <th>Receiver Suffix</th>
                    </tr>
                </thead>
                <tbody>
                    {codes.map(code =>
                        <tr key={code.id}>
                            <td><a href={'/code/' + code.id + "?diags=true"}>{code.id}</a></td>
                            <td>{code.campaignId}</td>
                            <td>{code.facilityId}</td>
                            <td>{code.receiverSuffix}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : Codes.renderCodes(this.state.codes);

        return (
            <div>
                <h1 id="tableLabel" >Codes</h1>
                {contents}
            </div>
        );
    }

    async fetchCodes() {
        const response = await fetch('/api/code');
        const data = await response.json();
        this.setState({ codes: data, loading: false });
    }
}
